import { Controller } from "stimulus";

const CLOSE_DELAY_MS = 300;
const VISIBLE_CLASS = "is-visible";

export default class extends Controller {
  disconnect() {
    this.cancelClose();
  }

  open() {
    this.cancelClose();
    this.element.classList.add(VISIBLE_CLASS);
  }

  close() {
    this.cancelClose();
    this.element.classList.remove(VISIBLE_CLASS);
  }

  onMouseLeave() {
    if (this.isExpanded()) this.scheduleClose();
  }

  cancelClose() {
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimer = setTimeout(() => this.close(), CLOSE_DELAY_MS);
  }

  onOutsideClick(event) {
    if (!this.isExpanded()) return;
    if (this.element.contains(event.target)) return;
    this.close();
  }

  onEsc(event) {
    if (event.key !== "Escape") return;
    if (!this.isExpanded()) return;
    this.close();
  }

  isExpanded() {
    return this.element.classList.contains(VISIBLE_CLASS);
  }
}
